import { useMemo } from 'react';
import { City, UserSimpleInfo } from 'src/types';
import { UserSimpleInfoForm } from '../users.types';

export const useUserAdapterModelToFormData = (user: UserSimpleInfo) => {
  const userFormData: UserSimpleInfoForm = useMemo(() => {
    return {
      ...user,
      city: user.city
        ? {
            value: (user.city as City).id,
            label: (user.city as City).name,
          }
        : null,
      agencies: user.agencies ? user.agencies.map((agency) => agency.agency.id) : [],
    };
  }, [user]);

  return {
    userFormData,
  };
};
